import { render, staticRenderFns } from "./payTaxesAndFees.vue?vue&type=template&id=67a737ca&scoped=true"
import script from "./payTaxesAndFees.vue?vue&type=script&lang=js"
export * from "./payTaxesAndFees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a737ca",
  null
  
)

export default component.exports